import { useLazyQuery } from '@apollo/client'

import { gql } from '@web/federation/gql'
import { federationApolloClient } from '@web/libs/apollo/federationClient'

export const UseTimelineQueryFragment = gql(/* GraphQL */ `
  fragment UseTimelineQueryFragment_Timeline on Timeline {
    id
    reviewGroup {
      ...convertToUIReviewSnippet_ReviewGroup
    }
  }
`)

const UseTimelineQuery = gql(`
  query UseTimelineQuery($id: ID!) {
    timeline(id: $id) {
      ... on Timeline_Succeed {
        timeline {
          ...UseTimelineQueryFragment_Timeline
        }
      }
    }
  }
`)

export const useTimelineQuery = () => {
  const [getTimeline] = useLazyQuery(UseTimelineQuery, {
    client: federationApolloClient,
    fetchPolicy: 'network-only',
  })

  return {
    getTimeline,
  }
}
